<div class="sub-heading">
  {{providefeedback}}
</div>
<div class="mx-2-5 mb-3-5">
  <div class="my-1 right-panel-label-color">
    {{provideFeedbacksubtext}}
  </div>
    <app-location-breadcrumb></app-location-breadcrumb>
</div>

<div class="mx-2-5 mb-3-5">
  <div [formGroup]="feedBackForm">
    <mat-form-field class="width-100" appHostListenerClick>
      <mat-label>{{typeoffeedback}}</mat-label>
      <mat-select #feedBackTypeSelect autofocusdropdown="true" placeholder="Select Feedback Type" formControlName="feedBackType">
        <mat-option class="bgc-blue" *ngFor="let type of feedbackTypeList" [value]="type">{{type}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="width-100">
      <mat-label class="textBox-text">{{yourfeedback}}</mat-label>
      <div class="textarea-wrapper flex-display">
        <textarea class="textBox-text textarea-padding" type="text" matInput cdkTextareaAutosize
                  cdkAutosizeMinRows="1"
                  cdkAutosizeMaxRows="6" (input)="annotationDescriptionChange($event.target.value)" formControlName="feedBackContent" maxlength="4000"></textarea>
        <div class="remaning">{{remainingText}}/4000</div>
      </div>
    </mat-form-field>

    <mat-error class="mat-field-hint mb-1 mt-1" style="font-size: 1rem;" *ngIf="feedbackvalidationError != ''"> {{feedbackvalidationError}}</mat-error>
  </div>

  <div class="flex-display">
    <button mat-button class="btn-secondary-action-close" (click)="closeOverlay()">{{globalcancel}}</button> 
    <button mat-button class="btn-primary-action-add" (click)="submittFeedback()">{{globalsubmit}}</button>
  </div>


</div>

<div class="mx-2-5 mb-3-5">
  <div class="generalFeedbackText">
    {{generalFeedbacktext}}
  </div>
  <div class="highlight-blue cursor-pointer feedback-view-margin" (click)="addGeneralFeedback()">
    <img src="../../../assets/icons/GeneralFeedback(General).svg" class="icon-image-para-action-feedback" alt="General Feedback">  &nbsp; <span class="underline feedback-view">{{generalFeedbacklink}}</span>
  </div>
</div>
